var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMute32 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.554 7.29v8.537l-1.5-1.454v-5.61L15.75 11.17l-1.093-1.06 4.704-3.427a.75.75 0 0 1 1.192.606m-9.2 5.204H9.845c-.743 0-1.346.602-1.346 1.346v4.367c0 .744.603 1.346 1.346 1.346h3.843a.75.75 0 0 1 .442.144l4.923 3.587v-3.09zm9.2 9.2 3.489 3.49a.75.75 0 0 0 1.06-1.061L8.335 7.353a.75.75 0 0 0-1.06 1.061l2.579 2.58h-.007A2.846 2.846 0 0 0 7 13.84v4.367a2.846 2.846 0 0 0 2.846 2.846h3.6l5.916 4.311a.75.75 0 0 0 1.192-.606z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMute32);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };